import type { GetStaticProps } from 'next';
import Head from 'next/head';

import {
  ProductTag,
  GetProductsDocument,
  GetProductsQuery,
  GetShopTagsDocument,
  GetShopTagsQuery,
  ssrFetchAll,
  initializeApollo,
  Product,
} from '@axis/graphql';

import { ProductCardGrid } from '@axis/components/ProductCardGrid';
import { ProductModal } from '@axis/components/ProductModal';

type ShopProps = {
  products: Array<Product>
  tags: ProductTag[];
  product?: Product;
}

function Shop({ products, tags, product }: ShopProps) {
  return (
    <main className="container mx-auto py-5">
      <Head>
        <title>Honey Mart | Shop</title>
        <meta name="description" content="Apparel + Gifts" />
        <link rel="icon" href="/favicon.ico" />
      </Head>
      <ProductCardGrid products={products} tags={tags} />
      {product && <ProductModal product={product} />}
    </main>
  );
}

export const getStaticProps: GetStaticProps = async () => {
  const apolloClient = initializeApollo();

  const products = await ssrFetchAll<GetProductsQuery, Product>(
    apolloClient,
    GetProductsDocument,
    'products',
    200,
  );

  const tags = await ssrFetchAll<GetShopTagsQuery, ProductTag>(
    apolloClient,
    GetShopTagsDocument,
    'productTags',
  );

  return {
    props: { products, tags },
  };
};

export default Shop;
